import { createFileRoute } from '@tanstack/react-router';
import { signerLinkContractQuery } from '@/services/creator-portal';
import { PortalFrame } from '@/features/creator-portal/portal-frame';
import { SignerLinkPage } from '@/features/creator-portal/signer-link/signer-page';

/**
 * A signer's own link to one contract (the creator's manager, or someone who gets the signed copy): public, no sign-in
 * and no team. The token in the path is the only key (the page sends it to the API in a header, never in the API's
 * path). It shares the creator portal's frame; the frame and the page are split out of the entry, so the sign-in
 * page's budget never pays for them. The loader starts the read and never waits for it.
 */
export const Route = createFileRoute('/sign/$token')({
  loader: ({ context: { queryClient }, params }) => {
    void queryClient.prefetchQuery(signerLinkContractQuery(params.token));
  },
  component: SignerLinkRoute,
});

function SignerLinkRoute() {
  const { token } = Route.useParams();
  return (
    <PortalFrame>
      <SignerLinkPage token={token} />
    </PortalFrame>
  );
}
